import { Button, Drawer, notification, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Radio2,
  Text2,
  Checkbox1,
  Date2,
  Select2,
} from "../../../../Components/FormComponents/InputFields";
import { UpdateGeoTagEmployeeApi } from "../../../../Services/GeoTag";
import { useNavigate } from "react-router-dom";
import { checkPleaseLogin } from "../../../../Services/GeneralFunctions";

export default function UpdateEmployee({
  open,
  onClose,
  defaultValues,
  getEmployeesData,
}) {
  const navigate = useNavigate();

  const { control, errors, handleSubmit, reset, setValue } = useForm();
  const [api, contextHolder] = notification.useNotification();
  const [geotagEnable, setGeotagEnable] = useState(true);

  const onSubmit = async (val) => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    console.log(val);
    try {
      const data = await UpdateGeoTagEmployeeApi(
        defaultValues._id,
        val,
        geotagEnable
      );

      if (
        data.data.message === "Please Login." ||
        data.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data.data.success) {
        api.success({
          message: data.data.message,
          placement: "top",
        });
        getEmployeesData();
        onClose();
      } else {
        api.error({
          message: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        placement: "top",
      });
    }
  };

  useEffect(() => reset(), [onClose]);

  useEffect(() => {
    console.log(defaultValues, "anshul");
    // setGeotagEnable(defaultValues?.is_geotag);
    setValue("geotagCheckbox", defaultValues?.is_geotag);
    setValue("name", defaultValues?.name);
    setValue("company", defaultValues?.company);

    setValue("employeeId", defaultValues?.employee_id);
    setValue("biometricId", defaultValues?.biometric_id);
    setValue("managerName", defaultValues?.manager.name);
    setValue("managerEmail", defaultValues?.manager.email);
    setValue("managerId", defaultValues?.manager.employee_id);
    setValue("officialemail", defaultValues?.email);
    setValue("dob", defaultValues?.dob?.split(" ")[0]);
    setValue("doj", defaultValues?.date_of_joining?.start_date?.split(" ")[0]);
    setValue("doe", defaultValues?.date_of_joining?.end_date?.split(" ")[0]);
    setValue("personalEmail", defaultValues?.personal_email);
    setValue("personalMobile", defaultValues?.mobile);
    setValue("designation", defaultValues?.designation);
    setValue("location", defaultValues?.location);
    setValue("department", defaultValues?.department);

    setValue("isActive", defaultValues?.is_active);
  }, [open]);

  return (
    <>
      {contextHolder}
      <Drawer
        title="Update employee details"
        onClose={onClose}
        open={open}
        contentWrapperStyle={{ width: "100vw" }}
        bodyStyle={{
          paddingBottom: 80,
        }}
        footer={
          <Space size="middle">
            <Button size="large" onClick={onClose}>
              Cancel
            </Button>
            <Button
              size="large"
              onClick={handleSubmit(onSubmit)}
              type="primary"
            >
              Submit
            </Button>
          </Space>
        }
        footerStyle={{ textAlign: "right" }}
      >
        {/* <Checkbox1
          control={control}
          errors={errors}
          id="geotagCheckbox"
          name="For GeoTag"
          onChange={(val) => setGeotagEnable(val.target.checked)}
          defaultChecked={geotagEnable}
        /> */}

        <Row>
          <Text2 control={control} errors={errors} id="name" name="Name" />
          <Text2
            control={control}
            errors={errors}
            id="employeeId"
            name="Employee ID"
            disabled
          />
          <Text2
            control={control}
            errors={errors}
            id="biometricId"
            name="Biometric ID"
            disabled
          />
          <Text2
            control={control}
            errors={errors}
            id="managerName"
            name="Manager Name"
          />
          <Text2
            control={control}
            errors={errors}
            id="managerEmail"
            name="Manager Email"
          />
          <Text2
            control={control}
            errors={errors}
            id="managerId"
            name="Manager ID"
          />
          {geotagEnable && (
            <Text2
              control={control}
              errors={errors}
              id="officialemail"
              name="Official Email"
            />
          )}
          <Select2
            control={control}
            errors={errors}
            id="company"
            name="Company"
            options={[
              {
                label: "DJT Corporation & Investments Pvt Ltd",
                value: "DJT Corporation & Investments Pvt Ltd",
              },
              {
                label: "IndoGulf Hospital & Diagnostics",
                value: "IndoGulf Hospital & Diagnostics",
              },
            ]}
          />

          {!geotagEnable && (
            <>
              <Date2
                control={control}
                errors={errors}
                id="dob"
                name="Date of Birth"
              />
              <Date2
                control={control}
                errors={errors}
                id="doj"
                name="Date of Joining"
              />
              <Date2
                control={control}
                errors={errors}
                id="doe"
                name="Date of Exit"
              />

              <Text2
                control={control}
                errors={errors}
                id="personalEmail"
                name="Personal Email"
              />
              <Text2
                control={control}
                errors={errors}
                id="personalMobile"
                name="Personal Mobile No"
              />

              <Text2
                control={control}
                errors={errors}
                id="designation"
                name="designation"
              />
              <Text2
                control={control}
                errors={errors}
                id="location"
                name="Location"
              />
              <Text2
                control={control}
                errors={errors}
                id="department"
                name="Department"
              />
            </>
          )}
          {geotagEnable && (
            <Radio2
              control={control}
              errors={errors}
              id="isActive"
              name="Is Active"
              options={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
            />
          )}
        </Row>
      </Drawer>
    </>
  );
}
